(function () {
  'use strict';

  function syncPrices() {
    var visiblePrice = document.querySelector('#price .money');
    if (!visiblePrice) return;
    var text = visiblePrice.textContent.trim();
    document.querySelectorAll('[data-monster-base-price]').forEach(function (node) {
      node.textContent = text;
    });
    var mobile = document.querySelector('[data-monster-mobile-price] strong');
    if (mobile) mobile.textContent = text;
    updateConfigurationTotal();
  }

  function selectedVariantPrice() {
    var option = document.querySelector('#product-selectors option:checked');
    return option ? parseInt(option.getAttribute('data-price') || '0', 10) : 0;
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((cents || 0) / 100);
  }

  function protectionPrice() {
    var documents = [document];
    document.querySelectorAll('iframe').forEach(function (frame) {
      try { if (frame.contentDocument) documents.push(frame.contentDocument); } catch (e) { /* cross-origin frame */ }
    });
    for (var d = 0; d < documents.length; d += 1) {
      var candidates = documents[d].querySelectorAll('[class*="extend"] input[type="radio"]:checked, [id*="extend"] input[type="radio"]:checked, input[type="radio"]:checked');
      for (var i = 0; i < candidates.length; i += 1) {
        var container = candidates[i].closest('label, li, div');
        var match = container && container.textContent.match(/\$([0-9,]+(?:\.\d{2})?)/);
        if (match) return Math.round(parseFloat(match[1].replace(/,/g, '')) * 100);
      }
    }
    return 0;
  }

  function updateConfigurationTotal() {
    var totalNode = document.querySelector('[data-monster-configuration-total]');
    if (!totalNode) return;
    var quantityNode = document.getElementById('qty');
    var quantity = Math.max(1, parseInt(quantityNode && quantityNode.value || '1', 10));
    var extras = 0;
    document.querySelectorAll('.upsu-chip[aria-pressed="true"]:not([aria-hidden="true"])').forEach(function (chip) {
      extras += parseInt(chip.getAttribute('data-upsell-price') || '0', 10);
    });
    var core = document.querySelector('[data-core-prepay-control]');
    var coreChecked = core && core.querySelector('[data-core-prepay-checkbox]:checked');
    if (coreChecked) extras += parseInt(core.getAttribute('data-core-price') || '0', 10);
    var formattedTotal = money(((selectedVariantPrice() + extras) * quantity) + protectionPrice());
    totalNode.textContent = formattedTotal;
    var stickyPrice = document.getElementById('sticky-price');
    if (stickyPrice) stickyPrice.textContent = formattedTotal;
  }

  function reorderPurchaseFlow() {
    var core = document.querySelector('[data-core-prepay-control]');
    var addBox = document.querySelector('.product-options-bottom .add-to-cart-box');
    if (core && core.closest('[data-monster-guided-step]')) return;
    if (core && addBox) addBox.insertAdjacentElement('beforebegin', core);
  }

  function initGuidedConfigurator() {
    var form = document.getElementById('product-main-form');
    var fitment = document.getElementById('product-variants');
    var orderCard = form && form.querySelector('.product-options-bottom');
    if (!form || !form.classList.contains('monster-guided-enabled') || !fitment || !orderCard) return;

    var core = document.querySelector('[data-core-prepay-control]');
    var total = orderCard.querySelector('.monster-pdp-live-total');
    var optionsWrap = form.parentElement;
    var priceBlock = document.querySelector('.product-redesign__product-shop .product-redesign__price');
    var inventory = document.querySelector('.live-inventory-count');
    var inventoryText = inventory ? inventory.textContent.replace(/\s+/g, ' ').trim() : 'Available to order';
    var shell = form.querySelector('[data-monster-guided-flow]');
    if (!shell) {
      shell = document.createElement('section');
      shell.className = 'monster-guided-flow';
      shell.setAttribute('data-monster-guided-flow', '');
      shell.setAttribute('aria-label', 'Configure your transmission');
      shell.innerHTML = [
      '<div class="monster-guided-progress">',
        '<div class="monster-guided-progress__copy"><span data-guided-count>Step 1 of 4</span><strong data-guided-title>Confirm fitment</strong></div>',
        '<div class="monster-guided-progress__track"><span data-guided-progress-bar></span></div>',
        '<div class="monster-guided-summary">',
          '<div class="monster-guided-assurance" aria-label="Purchase assurances"><span><i class="fa fa-check" aria-hidden="true"></i> Converter included</span><span><i class="fa fa-check" aria-hidden="true"></i> Dyno tested</span><span><i class="fa fa-check" aria-hidden="true"></i> Fitment reviewed</span><span><i class="fa fa-check" aria-hidden="true"></i> Warranty coverage</span></div>',
          '<div data-guided-slot="total"></div>',
        '</div>',
      '</div>',
      '<div class="monster-guided-body">',
        '<section class="monster-guided-step" data-monster-guided-step="fitment">',
          '<div class="monster-guided-heading"><span>Vehicle fitment</span><h3>Confirm vehicle fitment</h3><p>Choose the drivetrain, vehicle and model year. Monster reviews fitment before shipment.</p></div>',
          '<div data-guided-slot="fitment"></div>',
          '<div class="monster-guided-actions"><span></span><button type="button" class="monster-guided-primary" data-guided-next>Continue to core deposit <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div>',
        '</section>',
        '<section class="monster-guided-step" data-monster-guided-step="core" hidden>',
          '<div class="monster-guided-heading"><span>Refundable core deposit</span><h3>Choose when to pay the deposit</h3><p>Pay now or after checkout. The same transmission is reserved either way.</p></div>',
          '<div data-guided-slot="core"></div>',
          '<button type="button" class="monster-guided-choice" data-guided-pay-later><span><strong>Pay after checkout</strong><small>Monster will contact you before shipment</small></span><b>$0 today</b></button>',
          '<div class="monster-guided-actions"><button type="button" data-guided-back>Back</button><button type="button" class="monster-guided-primary" data-guided-next>Continue <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div>',
        '</section>',
        '<section class="monster-guided-step" data-monster-guided-step="protection" hidden>',
          '<div class="monster-guided-heading"><span>Optional protection</span><h3>Add protection or continue without it</h3><p>This choice is optional and will not block your order.</p></div>',
          '<div class="monster-guided-protection" data-guided-slot="protection"><div class="monster-guided-loading">Loading available protection options…</div></div>',
          '<div class="monster-guided-actions"><button type="button" data-guided-back>Back</button><button type="button" data-guided-skip>Skip protection</button><button type="button" class="monster-guided-primary" data-guided-next>Continue <i class="fa fa-arrow-right" aria-hidden="true"></i></button></div>',
        '</section>',
        '<section class="monster-guided-step monster-guided-review" data-monster-guided-step="review" hidden>',
          '<div class="monster-guided-heading"><span>Review order</span><h3>Ready to add to cart</h3><p>Review your choices or return to any completed step to edit them.</p></div>',
          '<div class="monster-guided-review-lines" data-guided-review-lines></div>',
          '<div data-guided-slot="review"></div>',
          '<button type="button" class="monster-guided-back-link" data-guided-back><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to protection</button>',
        '</section>',
      '</div>',
      ].join('');

      form.insertBefore(shell, fitment);
      shell.querySelector('[data-guided-slot="fitment"]').appendChild(fitment);
      shell.querySelector('[data-guided-slot="review"]').appendChild(orderCard);
      if (total) shell.querySelector('[data-guided-slot="total"]').appendChild(total);
    }
    if (core) {
      shell.querySelector('[data-guided-slot="core"]').appendChild(core);
      core.style.display = '';
    }
    document.body.classList.add('monster-guided-page');
    if (!shell.hasAttribute('data-server-rendered-guided-flow') && optionsWrap && priceBlock && priceBlock.parentElement) {
      priceBlock.insertAdjacentElement('beforebegin', optionsWrap);
    }

    var stepNames = ['Confirm fitment', 'Core deposit', 'Protection', 'Review order'];
    var steps = Array.prototype.slice.call(shell.querySelectorAll('[data-monster-guided-step]'));
    var tabs = Array.prototype.slice.call(shell.querySelectorAll('[data-guided-tab]'));
    var current = 0;
    var maxVisited = 0;
    var protectionDecision = 'Not added';

    function selectedFitment() {
      return Array.prototype.slice.call(fitment.querySelectorAll('.single-option-selector')).map(function (select) {
        return select.value;
      }).filter(Boolean).join(' · ') || 'Selected fitment';
    }

    function updateReview() {
      var review = shell.querySelector('[data-guided-review-lines]');
      var checkbox = core && core.querySelector('[data-core-prepay-checkbox]');
      var coreText = checkbox && checkbox.checked ? 'Pay deposit now' : 'Pay after checkout';
      if (review) review.innerHTML = [
        '<button type="button" data-guided-edit="0"><span>Fitment</span><strong>' + selectedFitment() + '</strong><em>Edit</em></button>',
        '<button type="button" data-guided-edit="1"><span>Core deposit</span><strong>' + coreText + '</strong><em>Edit</em></button>',
        '<button type="button" data-guided-edit="2"><span>Protection</span><strong>' + protectionDecision + '</strong><em>Edit</em></button>'
      ].join('');
    }

    function showStep(index) {
      index = Math.max(0, Math.min(steps.length - 1, index));
      current = index;
      maxVisited = Math.max(maxVisited, current);
      steps.forEach(function (step, i) { step.hidden = i !== current; });
      tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === current);
        tab.classList.toggle('is-complete', i < maxVisited || (maxVisited === steps.length - 1 && i < steps.length - 1));
        tab.disabled = i > maxVisited;
        tab.setAttribute('aria-current', i === current ? 'step' : 'false');
      });
      var count = shell.querySelector('[data-guided-count]');
      var title = shell.querySelector('[data-guided-title]');
      var bar = shell.querySelector('[data-guided-progress-bar]');
      if (count) count.textContent = 'Step ' + (current + 1) + ' of ' + steps.length;
      if (title) title.textContent = stepNames[current];
      if (bar) bar.style.width = (((current + 1) / steps.length) * 100) + '%';
      if (current === steps.length - 1) updateReview();
      shell.dispatchEvent(new CustomEvent('monster:guided-step', { bubbles: true, detail: { step: current + 1 } }));
    }

    function findExtendOffer() {
      return form.querySelector('.extend-product-offer') || document.querySelector('.extend-product-offer');
    }

    function placeExtendOffer() {
      var offer = findExtendOffer();
      var slot = shell.querySelector('[data-guided-slot="protection"]');
      if (!offer || !slot || slot.contains(offer)) return !!offer;
      var loading = slot.querySelector('.monster-guided-loading');
      if (loading) loading.remove();
      slot.appendChild(offer);
      return true;
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { if (!tab.disabled) showStep(parseInt(tab.getAttribute('data-guided-tab'), 10)); });
    });
    shell.addEventListener('click', function (event) {
      var edit = event.target.closest('[data-guided-edit]');
      if (edit) { showStep(parseInt(edit.getAttribute('data-guided-edit'), 10)); return; }
      if (event.target.closest('[data-guided-back]')) { showStep(current - 1); return; }
      if (event.target.closest('[data-guided-skip]')) { protectionDecision = 'Not added'; showStep(3); return; }
      if (event.target.closest('[data-guided-pay-later]')) {
        var checkbox = core && core.querySelector('[data-core-prepay-checkbox]');
        if (checkbox && checkbox.checked) { checkbox.checked = false; checkbox.dispatchEvent(new Event('change', { bubbles: true })); }
        showStep(2);
        return;
      }
      if (event.target.closest('[data-guided-next]')) {
        if (current === 2) protectionDecision = 'Reviewed';
        showStep(current + 1);
      }
    });
    fitment.addEventListener('change', function (event) {
      window.setTimeout(function () {
        if ((event.target && event.target.getAttribute('data-option') === 'option3') || (event.target && event.target.name === 'option-2')) showStep(1);
      }, 180);
    });
    if (core) core.addEventListener('change', function (event) {
      if (event.target && event.target.matches('[data-core-prepay-checkbox]') && event.target.checked) window.setTimeout(function () { showStep(2); }, 240);
    });
    placeExtendOffer();
    var observer = new MutationObserver(function () { if (placeExtendOffer()) observer.disconnect(); });
    observer.observe(form, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); var loading = shell.querySelector('.monster-guided-loading'); if (loading) loading.textContent = 'Protection options are unavailable right now. You can continue without adding a plan.'; }, 6000);
    showStep(0);
  }

  function initStickyCart() {
    var sticky = document.getElementById('sticky-atc');
    var mainButton = document.getElementById('add_to_cart_button');
    if (!sticky || !mainButton || !window.matchMedia('(min-width: 768px)').matches) return;

    var mainButtonVisible = false;

    function setVisibility() {
      var shouldShow = !mainButtonVisible && window.scrollY > 360;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          mainButtonVisible = entry.isIntersecting;
          setVisibility();
        });
      }, { threshold: 0.15 }).observe(mainButton);
    }

    window.addEventListener('scroll', setVisibility, { passive: true });
    setVisibility();
  }

  function collapseLowerSections() {
    document.querySelectorAll('.product-redesign__description .accordion').forEach(function (section) {
      section.classList.add('active');
    });
    document.querySelectorAll('.product-redesign__description li').forEach(function (item) {
      if (/truck models between 2016-2019.*8 speed 8l90/i.test(item.textContent || '')) item.remove();
    });
  }

  function refresh() {
    syncPrices();
  }

  document.addEventListener('DOMContentLoaded', function () {
    collapseLowerSections();
    initGuidedConfigurator();
    refresh();
    window.setTimeout(function () {
      reorderPurchaseFlow();
      initStickyCart();
      refresh();
    }, 500);
    window.setInterval(updateConfigurationTotal, 1200);
  });

  window.addEventListener('message', function () {
    window.setTimeout(updateConfigurationTotal, 30);
  });

  document.addEventListener('variant:change', function () {
    window.setTimeout(refresh, 60);
  });

  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('.product-options')) {
      window.setTimeout(refresh, 60);
    }
    window.setTimeout(updateConfigurationTotal, 20);
  });

  document.addEventListener('input', function (event) {
    if (event.target && event.target.id === 'qty') updateConfigurationTotal();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.upsu-chip, [class*="extend"]')) window.setTimeout(updateConfigurationTotal, 40);
  });
}());
